import React from "react";

import { useSelector } from "react-redux";

import {
  selectSkillCategoryCompletionPercentage,
  selectSkillCategorySkillIds,
  selectSkillCategoryTitle,
} from "@hubcapp/state";

import { SkillsAccordionStateProviderProps } from "./types";
import SkillsAccordion from "./SkillsAccordion";

const SkillsAccordionStateProvider: React.FC<SkillsAccordionStateProviderProps> = ({
  skillCategoryId,
  loading = false,
}) => {
  const skillIds = useSelector(selectSkillCategorySkillIds(skillCategoryId));
  const percentage = useSelector(
    selectSkillCategoryCompletionPercentage(skillCategoryId),
  );
  const title = useSelector(selectSkillCategoryTitle(skillCategoryId));

  return (
    <SkillsAccordion
      skillIds={skillIds}
      loading={loading || !skillIds}
      title={title || ""}
      percentage={percentage}
    />
  );
};

export default SkillsAccordionStateProvider;
